<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-red" sprite="queue" />
          Call Queues
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-red" sprite="queue" />
            Call Queues
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>

      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
          <el-button class="ml-10 hidden-xs-only" @click="doExport">
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-button v-if="!queueAdmin" @click="openCreateModal"
            >Add New</el-button
          >
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <create-form
      :createVisible="createVisible"
      :clearFormFields="clearFormFields"
      :createProcessing="createProcessing"
      :ivrOptions="ivrOptions"
      :cidNumOptions="cidNumOptions"
      :branch-options="branchOptions"
      :numInUse="numInUse"
      :draggableDestTypes="draggableDestTypes"
      @remoteSearchForCidNums="remoteSearchForCidNums"
      @checkAvailableNum="checkAvailableNum"
      @createOperation="createOperation"
      @cancelOperation="cancelOperation"
    />

    <edit-form
      :editVisible="editVisible"
      :clearFormFields="clearFormFields"
      :editProcessing="editProcessing"
      :ivrOptions="ivrOptions"
      :cidNumOptions="cidNumOptions"
      :branch-options="branchOptions"
      :numInUse="numInUse"
      :selectedQueue="selectedQueue"
      :draggableDestTypes="draggableDestTypes"
      @remoteSearchForCidNums="remoteSearchForCidNums"
      @checkAvailableNum="checkAvailableNum"
      @editOperation="editOperation"
      @cancelOperation="cancelOperation"
    />
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapActions } from "vuex";
import { globalEventBus } from "@/globalEventBus";
import feathersClient from "@/feathers/feathers-client";
import CreateForm from "./components/createForm";
import EditForm from "./components/editForm";
import { ExportToCsv } from "export-to-csv";
import { phoneNumberFormatter } from "@/globals/globals";

export default {
  name: "QueuesTable",

  components: {
    CreateForm,
    EditForm
  },

  data() {
    return {
      draggableDestTypes: [
        "SPECIAL",
        "CUSTOM",
        "IVR",
        "VOICEMAIL",
        "PLAYBACK",
        "HUNTLIST",
        "EXT",
        "QUEUE",
        "SMS",
        "MUSICONHOLD",
        "CONDITION",
      ],
      queuesChannel: null,
      selectedQueue: null,
      tableLoading: false,
      clearFormFields: false,
      editProcessing: false,
      editVisible: false,
      createVisible: false,
      createProcessing: false,
      tableData: [],
      allQueues: [],
      search: "",
      visibleActionsId: "",
      ivrOptions: [],
      cidNumQuery: "",
      numberQuery: "",
      numInUse: null,
      cidNumOptions: [],
      didOptions: [],
      didsQuery: "",
      branchOptions: [],
      total: 0,
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: () => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-red" sprite="queue" />
                </div>
              ];
            }
          }
        },
        {
          field: "name",
          title: "Name",
          minWidth: 150,
          sortable: true
        },
        {
          field: "number",
          title: "Number",
          minWidth: 100,
          sortable: true,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.numberFormatter(row.number)}</span>
              ]
            }
          }
        },
        {
          field: "ringStrategy",
          title: "Ring Strategy",
          minWidth: 100,
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [<span>{this.strategyMap(row.ringStrategy)}</span>];
            }
          }
        },
        {
          field: "recording",
          title: "Recording",
          minWidth: 75,
          sortable: true
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={"edit-" + row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  {
                    !this.queueAdmin &&
                    <el-button
                      id={"delete-" + row.id}
                      icon="el-icon-delete"
                      onClick={() => this.deleteOperation(row.id)}
                      class="table-action-button icon-red"
                    />
                  }
                </div>
              ];
            }
          }
        }
      ]
    };
  },
  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    },
    queueAdmin() {
      if (this.user) {
        return +this.user.userRole === 7;
      }
      return false;
    }
  },
  watch: {
    selectedTenant() {
      this.findQueues();
      this.getIvrOptions();
      this.getNumberOptions();
      this.queryBranches();
      feathersClient
        .service("channel-memberships")
        .remove(null, { query: { channelName: this.queuesChannel } });
      this.joinSocketChannel();
    },

    user() {
      this.findQueues();
      this.getIvrOptions();
      this.getNumberOptions();
      if (!this.queuesChannel) {
        this.joinSocketChannel();
      }
    },

    search: debounce(function() {
      this.searchQueues();
    }, 500),

    numberQuery: debounce(function() {
      const query = {
        tenantId: this.selectedTenant.id,
        number: this.numberQuery
      };
      const checkNumberService = feathersClient.service("check-number");
      checkNumberService.find({ query }).then(res => {
        this.numInUse = res;
      });
    }, 500)
  },

  methods: {
    ...mapActions("queues", {
      createQueues: "create",
      editQueue: "patch",
      deleteQueue: "remove"
    }),

    doExport() {
      const data = [...this.tableData];
      if (data.length) {
        const writeData = data.map(item => ({
          name: item.name,
          number: item.number ? item.number : "",
          strategy: this.strategyMap(item.ringStrategy),
          recording: item.recording
        }));

        const options = {
          filename: "call_queues",
          showLabels: true,
          headers: ["Name", "Number", "Ring Strategy", "Recording"]
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },

    searchQueues() {
      if (this.search.length) {
        this.tableData = this.allQueues.filter(
          data =>
            data.number.toLowerCase().includes(this.search.toLowerCase()) ||
            data.name.toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        this.tableData = [...this.allQueues];
      }
      this.total = this.tableData.length;
    },

    //General Form and Table Operations
    strategyMap(val) {
      const map = {
        RINGALL: "Ring all",
        RRMEMORY: "Round robin",
        RANDOM: "Random",
        LINEAR: "Linear",
        FEWESTCALLS: "Fewest calls",
        LEASTRECENT: "Least Recent"
      };

      return map[val] ? map[val] : val;
    },

    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    openCreateModal() {
      this.createVisible = true;
      this.clearFormFields = false;
      this.numInUse = null;
    },

    openEditModal(id) {
      this.clearFormFields = false;
      this.numInUse = null;
      feathersClient
        .service("queues")
        .get(id)
        .then(res => {
          this.selectedQueue = { ...res };
          this.editVisible = true;
        });
    },

    // ⭐️ CRUD ⭐️ //
    createOperation(createBody) {
      this.$confirm("Create call queue?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.createProcessing = true;

          this.createQueues(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Created successfully!",
                type: "success"
              });
              this.createProcessing = false;
              this.cancelOperation("create");
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.createProcessing = false;
            });
        })
        .catch(() => true);
    },

    editOperation(editBody) {
      this.$confirm("Edit call queue?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.editProcessing = true;

          this.editQueue([this.selectedQueue.id, editBody])
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited successfully!",
                type: "success"
              });
              this.editProcessing = false;
              this.cancelOperation("edit");
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.editProcessing = false;
            });
        })
        .catch(() => true);
    },

    deleteOperation(id) {
      this.$confirm("Process call queue delete?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.tableLoading = true;
          this.deleteQueue(id)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success"
              });
              this.tableLoading = false;
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.tableLoading = false;
            });
        })
        .catch(() => true);
    },

    cancelOperation(type) {
      if (type === "create") {
        this.createVisible = false;
      }
      if (type === "edit") {
        this.editVisible = false;
      }
      this.clearFormFields = true;
    },

    getIvrOptions() {
      if (!this.queueAdmin) {
        feathersClient
          .service("ivrs")
          .find({
            query: {
              tenantId: this.selectedTenant.id
            }
          })
          .then(res => {
            this.ivrOptions = [...res];
          }).catch(() => {
            this.ivrOptions = [];
        });
      }
    },

    remoteSearchForCidNums(query) {
      this.cidNumQuery = query;
      this.getNumberOptions();
    },

    getNumberOptions() {
      const didParams = {
        query: {
          tenantId: this.selectedTenant.id,
          allowEmergency: "",
          $limit: 10
        }
      };

      if (this.cidNumQuery.length) {
        didParams.query.$or = [{ number: { $like: `%${this.cidNumQuery}%` } }];
      }

      this.cidNumOptions = [];
      feathersClient
        .service("dids")
        .find(didParams)
        .then(res => {
          this.cidNumOptions = [];
          this.cidNumOptions = res.map(item => ({
            key: item.id,
            label: item.number
          }));
        });
    },

    numberFormatter(val) {
      return phoneNumberFormatter(val);
    },

    checkAvailableNum(query) {
      this.numberQuery = query;
    },

    findQueues() {
      this.tableLoading = true;
      this.tableData = [];
      const query = {
        tenantId: this.selectedTenant.id
      };

      // ⭐️ Grab queues for queue managers ⭐️ //
      if (this.queueAdmin) {
        query.id = { $in: this.user.adminQueues };
      }

      feathersClient
        .service("queues")
        .find({
          query
        })
        .then(res => {
          this.tableData = [...res];
          this.allQueues = [...res];
          this.total = res.length;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    queryBranches(){
      feathersClient.service('branches').find({
        query: {
          tenantId: this.selectedTenant.id
        }
      }).then( (res) => {
        this.branchOptions = [...res];
      }).catch( () => {
        this.branchOptions = [];
      })
    },

    joinSocketChannel() {
      if (!this.queueAdmin) {
        const channelService = feathersClient.service("channel-memberships");
        const data = {
          roomType: "admins",
          tenantId: this.selectedTenant.id
        };
        channelService.create(data).then(res => {
          this.queuesChannel = `${data.roomType}/${data.tenantId}`;
        });
      }
    },

    removeListeners() {
      feathersClient.service("queues").removeListener("patched");
      feathersClient.service("queues").removeListener("created");
      feathersClient.service("queues").removeListener("removed");
      globalEventBus.$off("appReconnected");
    }
  },

  created() {
    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on("appReconnected", () => {
      this.joinSocketChannel();
    });

    //record was edited
    //always refresh did destination options
    feathersClient.service("queues").on("patched", data => {
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allQueues.findIndex(
        item => item.id === data.id
      );
      if (updateIndex >= 0) {
        this.tableData.splice(updateIndex, 1, data);
      }
      if (updateAllIndex >= 0) {
        this.allQueues.splice(updateAllIndex, 1, data);
      }
    });

    //record was created
    feathersClient.service("queues").on("created", data => {
      this.tableData.push(data);
      // this.allCallGroups.push(data);
    });

    //record was deleted
    feathersClient.service("queues").on("removed", data => {
      const indexToRemove = this.tableData.findIndex(
        item => item.id === data.id
      );
      const indexAllToRemove = this.allQueues.findIndex(
        item => item.id === data.id
      );
      if (indexToRemove >= 0) {
        this.tableData.splice(indexToRemove, 1);
      }
      if (indexAllToRemove >= 0) {
        this.allQueues.splice(indexAllToRemove, 1);
      }
    });
  },

  mounted() {
    if (this.user) {
      this.findQueues();
      this.getIvrOptions();
      this.getNumberOptions();
      this.queryBranches();
      this.joinSocketChannel();
    }
  },

  beforeDestroy() {
    feathersClient
      .service("channel-memberships")
      .remove(null, { query: { channelName: this.queuesChannel } });
    this.removeListeners();
  }
};
</script>

<style lang="scss" scoped>
.table-box {
  overflow: auto;
}

.table-actions {
  position: absolute;
  top: -8px;
  right: 30px;
  background: #fff;
  padding: 5px;
  border-radius: 10px;
  border: 1px solid lightgray;
  z-index: 1;
}
</style>
